// ── Toast Component ───────────────────────────────────────────────────────────
import { useToastStore } from '../../hooks/useToast';

export function ToastContainer() {
  const { toasts, remove } = useToastStore();
  if (!toasts.length) return null;
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast ${t.type}`} onClick={() => remove(t.id)} style={{ cursor: 'pointer' }}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
